<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.Headline }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content" ref="mainContainer">
        <div v-if="loaded">
          <h3 class="title">{{ model.Headline }}</h3>
          <div class="attrs">
            <span class="time">赛事时间：{{
                model.StartTime | dateTimeFilter("yyyy-MM-dd")
              }}至{{ model.EndTime | dateTimeFilter("yyyy-MM-dd") }}</span>
            <span class="source">来源：{{ model.Author || model.Organization }}</span>
            <span class="source">阅览量：{{ model.ViewCount }}</span>
            <span class="source tag">贴文类型：{{ model.Type }}</span>
          </div>
          <!-- <div class="content" v-html="model.Illustration"></div> -->
          <div class="content" v-html="model.Contents"></div>
          <div v-if="commentList.length" v-loading="loading" style="width:100%">
            <column-header2 :data="metaData"></column-header2>

            <el-row :gutter="28" class="sectionContent">
              <el-col :span="24">
                <div v-cloak v-if="commentList.length" class="comment-container">
                  <div v-for="(v, i) in commentList" :key="i" class="content-panel">
                    <div class="comment-first">
                      <div class="left">
                        <div>
                          <span class="commenter">{{ v.CommenterName }}</span>
                          ：{{ v.Comment }}
                        </div>
                      </div>
                      <div class="right">
                        <div>{{ formartDate(v.CreatedTime, "minutes") }}</div>
                        <el-button type="text" v-if="isLogin&&model.ReadOnlyId != 1" size="mini" icon="fa fa-comment-o" @click="reply(v)">回复</el-button>
                        <el-button v-if="v.IsMyself" class="hover-danger" type="text" size="mini" icon="fa fa-trash-o" @click="handleDelete(v.Id)">删除</el-button>
                      </div>
                    </div>
                    <div v-for="(item, index) in v.Children" :key="index" class="comment-second">
                      <div class="left">
                        <span class="commenter">{{ item.CommenterName }}</span>
                        回复
                        <span class="commenter">{{ item.ReceiverName }}</span>
                        ：{{ item.Comment }}
                      </div>
                      <div class="right">
                        <div>
                          {{ formartDate(item.CreatedTime, "minutes") }}
                        </div>
                        <el-button v-if="isLogin&&model.ReadOnlyId != 1" type="text" size="mini" icon="fa fa-comment-o" @click="reply(item)">回复</el-button>
                        <el-button v-if="item.IsMyself" class="hover-danger" type="text" size="mini" icon="fa fa-trash-o" @click="handleDelete(item.Id)">删除</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-pagination v-show="total > 0" class="g-pagination" :current-page="listQuery.PageIndex" :page-size="listQuery.PageSize" layout="prev, pager, next" :total="total" background @current-change="getCommonList">
          </el-pagination>
          <div class="isLogin">
            <el-form ref="form" :disabled="!isLogin" :model="form">
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <el-input type="textarea" placeholder="评论赛事" v-model="form.Comment" :autosize="{ minRows: 4 }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button @click="onSubmit()">回复</el-button>
            </el-form>
            <div class="btn_box" v-if="model.ReadOnlyId == 1">
              <el-button type="primary" class="login_btn" @click="login">禁止评论</el-button>
            </div>
            <div class="btn_box" v-else-if="!isLogin">
              <el-button type="primary" class="login_btn" @click="login">登录参与讨论</el-button>
            </div>
          </div>
          <el-dialog :close-on-click-modal="false" title="请输入评论" :visible.sync="dialogVisible">
            <el-input v-model="replyParams.Comment" :autosize="{ minRows: 4 }" type="textarea"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="sendReply">确 定</el-button>
              <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
          </el-dialog>
          <div class="relative">
            <div class="prev">
              上一篇：
              <span v-if="prev" @click="handleSwitch(prev)" class="link-text text-over">
                {{ prev.Headline }}
              </span>
              <span v-else>没有了</span>
            </div>
            <div class="next">
              下一篇：
              <span v-if="next" @click="handleSwitch(next)" class="link-text text-over">
                {{ next.Headline }}
              </span>
              <span v-else>没有了</span>
            </div>
          </div>
        </div>
        <div class="error-data" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import Mgr from "@/services/SecurityService";
import { dateTimeFilter } from "_f/index";
import { getCurrentAndAdjacent } from "api/app";
import {
  addViewCount,
  getCommentPagedList,
  deleteCommentMatch,
  addCommentMatch
} from "api/innovation";
import { Loading } from "element-ui";
import tools from "@/mixins/content-tools";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";

export default {
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  filters: {
    dateTimeFilter
  },
  mixins: [tools],
  data() {
    return {
      metaData: { name: "相关评论" },
      form: {
        Match: this.$route.query.id,
        Comment: "",
        RelateReply: "",
        ReplyTo: ""
      },
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1"
      },
      prev: null,
      next: null,
      id: null,
      name: "",
      loaded: false,
      listQuery: {
        PageIndex: 1,
        PageSize: 10,
        Id: this.$route.query.id
      },
      total: 0,
      commentList: [],
      matchId: this.$route.query.id,
      detailInfo: {},
      loading: false,
      templateObject: {},
      replyParams: {
        Match: this.$route.query.id,
        Comment: "",
        RelateReply: "",
        ReplyTo: ""
      },
      dialogVisible: false,
      isLogin: false,
      userMgr: new Mgr()
    };
  },
  async created() {
    await this.checkLogin();
    await this.init();
    await this.addView();
    await this.getCommonList();

  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    async checkLogin() {
      this.isLogin = await this.userMgr.isLogin();
      console.log(this.isLogin);
      if (this.isLogin) {
        this.userMgr.getUser()
          .then(() => {
            this.$store.dispatch("user/getInfo");
          })
          .catch(err => {
            console.error("getUser", err);
          });
      }
    },
    login() {
      this.userMgr.signIn();
    },
    async loadData() {
      this.loaded = false;
      let loadingOptions = {
        target: this.$refs.mainContainer,
        fullscreen: false
      };
      let loadingInstance = Loading.service(loadingOptions);
      const res = await getCurrentAndAdjacent({
        name: this.name,
        id: this.id,
        college: this.collegeData.college.Id
      });
      if (res) {
        this.model = res.current;
        this.prev = res.prev;
        this.next = res.next;
        this.loaded = true;
      } else {
        this.$message.error("异常数据");
      }
      loadingInstance.close();
    },
    init() {
      this.name = this.$route.params.name;
      this.id = this.$route.query.id;
      this.loadData();
    },
    addView() {
      addViewCount({ Match: this.$route.query.id });
    },
    handleSwitch(item) {
      this.id = item.Id;
      this.loadData();
    },
    getCommonList() {
      getCommentPagedList(this.listQuery)
        .then(res => {
          console.log(res);
          this.total = res.TotalCount;
          this.commentList = res.Data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDelete(id) {
      this.$confirm("确定要删除所选数据吗?删除后将无法恢复！", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = { MatchCommentId: id };
          deleteCommentMatch(params).then(response => {
            let isSuccess = false;
            if (response.Status === 0) {
              isSuccess = response.IsSuccess;
            }
            if (isSuccess) {
              this.getCommonList();
              this.$message({
                type: "success",
                message: response.Message || "删除成功"
              });
            } else {
              this.$message({
                type: "error",
                message: response.Message || "删除失败"
              });
            }
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    reply(v) {
      // this.templateObject = Object.assign({}, v)
      this.dialogVisible = true;
      if (v !== 1) {
        this.replyParams.RelateReply = v.RelateReply || v.Id;
        this.replyParams.ReplyTo = v.Commenter;
      }
    },
    sendReply() {
      if (this.loading) return;
      this.dialogVisible = false;
      if (this.replyParams.Comment.trim() === "") {
        this.$message({
          type: "error",
          message: "评论不能为空"
        });
        this.replyParams = {
          Match: this.$route.params.id,
          Comment: "",
          RelateReply: "",
          ReplyTo: ""
        };
        return;
      }
      this.loading = true;
      addCommentMatch(this.replyParams)
        .then(response => {
          let isSuccess = false;
          if (response.Status === 0) {
            isSuccess = response.IsSuccess;
          }
          if (isSuccess) {
            // this.$router.back(-1)
            this.replyParams = {
              Match: this.$route.params.id,
              Comment: "",
              RelateReply: "",
              ReplyTo: ""
            };
            this.getCommonList();
            this.$message({
              type: "success",
              message: response.Message || "回复成功"
            });
          } else {
            this.$message({
              type: "error",
              message: response.Message || "回复失败"
            });
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    onSubmit() {
      if (this.loading) return;
      this.dialogVisible = false;
      debugger;
      if (this.form.Comment.trim() === "") {
        this.$message({
          type: "error",
          message: "评论不能为空"
        });
        this.form = {
          Match: this.$route.query.id,
          Comment: "",
          RelateReply: "",
          ReplyTo: ""
        };
        return;
      }
      this.loading = true;
      addCommentMatch(this.form)
        .then(response => {
          let isSuccess = false;
          if (response.Status === 0) {
            isSuccess = response.IsSuccess;
          }
          if (isSuccess) {
            // this.$router.back(-1)
            this.form = {
              Match: this.$route.query.id,
              Comment: "",
              RelateReply: "",
              ReplyTo: ""
            };
            this.getCommonList();
            this.$message({
              type: "success",
              message: response.Message || "回复成功"
            });
          } else {
            this.$message({
              type: "error",
              message: response.Message || "回复失败"
            });
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.isLogin {
  margin-top: 20px;
  position: relative;
  .btn_box {
    position: absolute;
    border-radius: 4px;
    top: -8px;
    bottom: -8px;
    left: -8px;
    right: -8px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.1);
  }
}
.show-detail {
  // padding: 0 100px;
  flex-grow: 1;
  // flex-shrink: 0;
}
.title {
  font-size: 16px;
  font-weight: bold;
  padding-top: 20px;
  // border-top: solid 4px #999999;
}
.comment-container {
  padding: 20px;
  // background-color: #eeeeee;
  margin-bottom: 20px;
}
.comment-first {
  // background-color: #eeeeee;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 1px solid #999999;
  margin-bottom: 30px;
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
}
.comment-second {
  margin-left: 20px;
  padding: 20px;
  // background-color: #e9e9e9;
  margin-left: 20px;
  border-left: solid 4px $primary-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
}
.content-panel {
  padding: 10px 0;
  // background-color: red;
}
.viewBack {
  margin-top: 20px;
}
.commenter {
  padding: 0 2px;
  margin: 0 5px;
  background: rgba(69, 80, 238, 0.1);
  border-radius: 2px;
}
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 0 0 15px 0;
    line-height: 1.4em;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 18px;
    padding-bottom: 24px;
    .source {
      padding-left: 30px;
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0 40px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    color: #999999;
    .link-text {
      max-width: 500px;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .prev {
      display: flex;
      align-items: center;
      flex: 1;
    }
    .next {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
